import { type IGetWagerUseCase, type IWagerService, NotFoundError } from '../../../domain/entry.js';

/**
 * Use case for getting a wager containing a coupon.
 *
 * @param wagerService Wager service dependency
 * @returns Use case executor for getting wagers
 */
export function getWagerUseCase(wagerService: IWagerService): IGetWagerUseCase {
  return {
    execute: async ({ wagerId }): ReturnType<IGetWagerUseCase['execute']> => {
      const wager = await wagerService.getWagerAsync(wagerId);

      if (!wager) {
        throw new NotFoundError(`Wager ${wagerId} not found`);
      }

      return wager;
    },
  };
}
